/**
 * RESPONSIBILITY: choose between a framework screen and the site. Nothing else.
 *
 * The account menu is part of the header, not a bar above it — see site/AccountMenu.
 *
 *   ScreenRouter        which screen a URL maps to
 *   SitePage            which sections appear, in what order
 *   useDocumentChrome   palette, tab title, theme-colour
 *   DevBar              the flag-gated inspector
 */
import { useHash } from '@framework/react';
import { ScreenRouter } from './ScreenRouter';
import { SitePage } from './SitePage';
import { DevBar } from './DevBar';
import { useDocumentChrome } from './useDocumentChrome';

export default function App() {
  const hash = useHash();

  useDocumentChrome();

  const screen = ScreenRouter({ hash });
  if (screen) return <>{screen}</>;

  return (
    <>
      <SitePage />
      <DevBar />
    </>
  );
}
